/**
 * The language registry, derived from the folders that exist.
 *
 * `import.meta.glob` without `eager` gives one dynamic import per language, which Vite turns into
 * one chunk per language. Nothing here lists the languages by hand: create `content/<code>/` with
 * an `index.ts` and it is picked up. The only other step is a display name in `lib/ui.ts`, which a
 * switcher needs a human to write anyway.
 */
const loaders = import.meta.glob('./*/index.ts') as Record<
  string,
  () => Promise<{ default: Record<string, string> }>
>;

export const AVAILABLE_LANGS: string[] = Object.keys(loaders)
  .map((p) => p.split('/')[1])
  .sort();

export async function loadLanguage(code: string): Promise<Record<string, string> | null> {
  const loader = loaders[`./${code}/index.ts`];
  if (!loader) return null;
  return (await loader()).default;
}
